export default __webpack_public_path__ + "static/media/LHCard.959cf116.webp";